import type { QueryClient } from '@tanstack/react-query';

import type { LocationId } from '@brightlocal/shared';

import { ensureLocation } from './ensureLocation';
import { rememberRecentLocation } from '../hooks/useRecentLocationsStore';

interface LoadLocationRouteParams {
  /** Router-context query client the `$id` loader runs with. */
  queryClient: QueryClient;
  /** Numeric location id from the route params. */
  locationId: LocationId;
  /** The signed-in user — the visit lands in their Recents. */
  userId: number;
}

/**
 * The `$id` route loader: loads the location and records the visit in the sidebar switcher's
 * Recents. A failed load throws before anything is recorded, so a 403 or 404 never reaches Recents.
 */
export const loadLocationRoute = async ({ queryClient, locationId, userId }: LoadLocationRouteParams) => {
  const location = await ensureLocation({ queryClient, locationId });

  if (location !== null) {
    rememberRecentLocation({ userId, location });
  }

  return location;
};
